export enum Role {
	admin = "admin",
}

export interface Profile {
	roles: Role[];
}
